// extracted by mini-css-extract-plugin
export default {"container":"Location_container__ZS7Sj","wrapper":"Location_wrapper__VDh+q"};